<template>
  <div class="DefaultLayout">
    <NavigationDrawer />

    <BitrixLoginModal />
    <LoginModal />
    <RegisterModal />

    <SnackBar />

    <VAppBar
      app
      color="primary"
      dark
      elevate-on-scroll
    >
      <VAppBarNavIcon @click.stop="$store.commit('ui/toggleDrawer')" />
      <VToolbarTitle :class="{ 'pl-0': $vuetify.breakpoint.smAndDown }">
        <span
          v-for="(breadcrumbsItem, i) in breadcrumbs"
          :key="i"
          class="d-inline-block"
        >
          <template
            v-if="
              i === 0 ||
                i === (breadcrumbs.length - 1) ||
                $vuetify.breakpoint.smAndUp"
          >
            <AppLink
              :to="resolveBreadcrumbsProp(breadcrumbsItem, 'to')"
              class="white--text"
              :class="{
                'truncate-breadcrumbs': i !== (breadcrumbs.length - 1) &&
                  $vuetify.breakpoint.smAndDown
              }"
              v-text="resolveBreadcrumbsProp(breadcrumbsItem, 'title')"
            />
            <VIcon
              v-if="i !== (breadcrumbs.length - 1)"
              class="px-1"
              style="padding-bottom: 3px"
            >mdi-chevron-right</VIcon>
          </template>
        </span>
      </VToolbarTitle>
      <VSpacer />
      <!--<VThemeProvider light>-->
      <!--  <WorkTimeButton-->
      <!--    v-if="authorized && $vuetify.breakpoint.mdAndUp"-->
      <!--  />-->
      <!--</VThemeProvider>-->
    </VAppBar>

    <VContent>
      <VContainer
        class="fill-height"
        fluid
      >
        <VRow>
          <VCol>
            <slot />
          </VCol>
        </VRow>
      </VContainer>
    </VContent>
    <VFooter
      color="primary"
      app
    >
      <span class="white--text">&copy; IT-Solution {{ thisYear }}</span>
    </VFooter>
  </div>
</template>

<script>
import moment from 'moment'
import * as R from 'ramda'

import SnackBar from '../components/SnackBar'
import NavigationDrawer from '../components/NavigationDrawer'
import BitrixLoginModal from '../components/BitrixLoginModal'
import LoginModal from '../components/LoginModal'
import RegisterModal from '../components/RegisterModal'
// import WorkTimeButton from '../components/WorkTimeButton'

export default {
  components: {
    SnackBar,
    RegisterModal,
    BitrixLoginModal,
    LoginModal,
    NavigationDrawer,
    // WorkTimeButton,
  },
  data() {
    return {
      thisYear: moment().year(),
    }
  },
  computed: {
    authorized() { return !!this.$store.state.auth.token },
    breadcrumbs() {
      const breadcrumbs = this.$route.meta.breadcrumbs
      return R.is(Function, breadcrumbs)
        ? breadcrumbs({ route: this.$route, $store: this.$store })
        : breadcrumbs
    },
  },
  methods: {
    resolveBreadcrumbsProp(breadcrumbsItem, propName) {
      const item = R.is(Function, breadcrumbsItem)
        ? breadcrumbsItem({ route: this.$route, $store: this.$store })
        : breadcrumbsItem
      const propValue = item[propName]
      return R.is(Function, propValue)
        ? propValue({ route: this.$route, $store: this.$store })
        : propValue
    },
  },
}
</script>

<style lang="sass" scoped>
  .truncate-breadcrumbs
    display: inline-block
    vertical-align: bottom
    max-width: 100px
    overflow: hidden
    text-overflow: ellipsis
</style>
